import { ActionTypes, Actions } from '@appStore/contracts/actions';
import { Budget } from '@model';

export interface State {
  budgetLoaded: boolean;
  budgetLoading: boolean;
  budgetFailed: boolean;
  budgets: Budget[];
  selectedBudget: Budget;
  prognosisLoaded: boolean;
  prognosisLoading: boolean;
  prognosisFailed: boolean;
  prognosis: Budget;
  selectedPriceListCode: string;
  selectedTabIndexPrognosis: number;
}

export const initialState: State = {
  budgetLoaded: false,
  budgetLoading: false,
  budgetFailed: false,
  budgets: [],
  selectedBudget: null,
  prognosisLoaded: false,
  prognosisLoading: false,
  prognosisFailed: false,
  prognosis: null,
  selectedPriceListCode: null,
  selectedTabIndexPrognosis: 0
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    // Budgets
    case ActionTypes.BudgetLoadData:
      return { ...state, budgetLoaded: false, budgetLoading: true, budgetFailed: false, selectedBudget: null };
    case ActionTypes.BudgetLoadDataSuccess:
      let oldBudget = state.budgets.find(b => b.contractId === action.payload.contractId);
      let newBudgetList = state.budgets.map(b => ({ ...b }));

      if (oldBudget) {
        newBudgetList = newBudgetList.map(budget => {
          if (budget.contractId === action.payload.contractId) {
            return action.payload;
          }

          return budget;
        });
      } else {
        newBudgetList.push(action.payload);
      }

      return {
        ...state,
        budgetLoaded: true,
        budgetLoading: false,
        budgetFailed: false,
        budgets: newBudgetList,
        selectedBudget: action.payload
      };
    case ActionTypes.BudgetLoadDataFail:
      return { ...state, budgetLoaded: false, budgetLoading: false, budgetFailed: true, selectedBudget: null };

    case ActionTypes.BudgetSetSelected:
      return {
        ...state,
        selectedBudget:
          state.selectedBudget && state.selectedBudget.contractId === action.payload
            ? state.selectedBudget
            : state.budgets.find(budget => budget.contractId === action.payload)
      };

      // Prognosis
    case ActionTypes.PrognosisLoadData:
      return { ...state, prognosisLoaded: false, prognosisLoading: true, prognosisFailed: false };
    case ActionTypes.PrognosisLoadDataSuccess:
      return {
        ...state,
        prognosisLoaded: true,
        prognosisLoading: false,
        prognosisFailed: false,
        prognosis: action.payload
      };
    case ActionTypes.PrognosisLoadDataFail:
      return { ...state, prognosisLoaded: false, prognosisLoading: false, prognosisFailed: true };
    case ActionTypes.SelectPriceListCode:
      return { ...state, selectedPriceListCode: action.payload };
    case ActionTypes.ClearPrognosisData:
      return {
        ...state,
        prognosisLoaded: false,
        prognosisLoading: false,
        prognosisFailed: false,
        prognosis: null
      };
    case ActionTypes.SelectTabIndexPrognosis:
        return {...state, selectedTabIndexPrognosis: action.payload };
  
  }
  return state;
}

export const _getBudgets = (state: State) => state.budgets;
export const _getBudgetLoaded = (state: State) => state.budgetLoaded;
export const _getBudgetLoading = (state: State) => state.budgetLoading;
export const _getBudgetFailed = (state: State) => state.budgetFailed;
export const _getSelectedBudget = (state: State) => state.selectedBudget;

export const _getPrognosis = (state: State) => state.prognosis;
export const _getPrognosisLoaded = (state: State) => state.prognosisLoaded;
export const _getPrognosisLoading = (state: State) => state.prognosisLoading;
export const _getPrognosisFailed = (state: State) => state.prognosisFailed;

export const _getSelectedPriceListCode = (state: State) => state.selectedPriceListCode;
export const _getSelectedTabIndexPrognosis = (state: State) => state.selectedTabIndexPrognosis;
